import { get, post, download } from './request'

export let paginate = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let remove = (signin, success, failure) => post(
  `api/user/signin/${signin}/remove`, {}, success, failure
)

export let removeAll = (success, failure) => post(
  `api/user/signin/remove/all`, {}, success, failure
)

export let downloadAll = (success, failure) => download(
  `api/user/signins/export`, success, failure
)
